<template>
  <div id='productAddCart'>
	  <Alert v-if='AlertShow' :alertMsg="alertMsg"  />
		<div class='creatcartBox' :class='addCartShow?"creatcartBoxtop":"creatcartBoxbottom"' >
		        <div class='creatcartTitle' catchtouchmove="noHandle">
		          <div class='creatcartName'>将<span>{{goods.goods_name}}</span>加入</div>
		
					   <img :src="deleteImg"  @click="closeAddCart" class='creatcartClose' style='cursor:pointer;'></img>
		
		         
		        </div>
		        <div v-if='noCart' class='noCartBox'>
		             <div class='noCartBoxTitle'>什么都没有</div>
		              <div class='noCartBoxTxt'>你还没有任何橘袋哦~</div>
		              <div class='noCartBoxBtn' @click="newCart">新增自选橘袋</div>
		        </div>
		
		
		        <div class='creatcartRowBox'>
		              <div style="height:0.2rem;"></div>
		              <div  class='creatcartRow' v-for='(item,index) in cartList'  >
		                 
		                  <div class='rowcartImg' @click='toCartDetail(item.id)'>
		                      <div class='rowcartLab lab0' v-if='item.source==0'>自选</div>
		                      <div class='rowcartLab'  v-if='item.source==1'>报告</div>
		                      <div class='rowcartLab lab2'  v-if='item.source==2'>套餐</div>
		                      <div class='rowcartLab'  v-if='item.source==3'>好友</div>
		                      <img  :src="item.img"></img>
		                  </div>
		                  <div class='rowcartRight'>
		                      <div class='rowcartTitle' @click='toCartDetail(item.id)'>
		                          <div class='rowcartTitleName' v-if='index==0&&newCarRedName'>{{item.cartName}}<span v-if='index==0&&newCarRedName'>最近创建</span></div>
		                          <div  class='rowcartTitleName' v-else>{{item.name}}</div>
		                          <div class='rowcartTitleTxt'>每日{{item.goodsType}}种，共{{item.goodsNum}}颗</div>
		                      </div>
		                      <!-- 自选 -->
		                      <div class='rowcartStaus' v-if='item.source==0'>
											<img :src='addingImg' v-if='!item.isHave' @click="addCartFN(item)"   class='rowcartStausImg'></img>
											<img :src='addedImg' v-if='item.isHave' @click="cutCartFN(item)"  class='rowcartStausImg'></img>           
		                      </div> 
		                      <!-- 报告不含孕产 -->
		                      <div class='rowcartStaus'  v-if='item.source==1&&item.status==1'>
						
											<img :src='addingImg' v-if='!item.isHave' @click="addCartFN(item)"   class='rowcartStausImg'></img>
											<img :src='addedImg' v-if='item.isHave' @click="cutCartFN(item)"  class='rowcartStausImg'></img> 
								
		                                
		                      </div>
		                      <!-- 报告含有孕产 -->
		                      <div class='rowcartStaus'  v-if='item.source==1&&item.status!=1'>
		                              <div  class='rowcartStausTxt'>不可调整</div>
		                              <div class='cartRowcover'  @click='toCartDetail(item.id)'></div>
		                      </div>  
		                      <!-- 套餐 -->
		                      <div class='rowcartStaus' v-if='item.source==2'>
		                              <div  class='rowcartStausTxt'>不可调整</div>
		                              <div class='cartRowcover'  @click='toCartDetail(item.id)'></div>
		                      </div>
		                      <!-- 好友报告 -->
		                      <div class='rowcartStaus' v-if='item.source==3'>
		                              <div  class='rowcartStausTxt'>不可调整</div> 
		                              <div class='cartRowcover'  @click='toCartDetail(item.id)' ></div>
		                      </div>
		                  </div>
		              </div>
					  <div  class='creatcartRow'></div>
		          
		        </div>
		      
		        <div class='creatcartBtn app-btn--large app-btn--shadow' v-if='!noCart' @click="newCart">新增自选橘袋</div>
		    </div>
		
		  <!-- 删除橘袋 -->
		   <div class='delCartBox' v-if='delCartShow'  @touchmove.stop.prevent="noHandle">
		        <div class='delCartBoxName'>删除橘袋</div>
		        <div class='delCartBoxTxt'>是否删除{{delCartname}}？</div>
		        <div class='delcartBtn' @click="cartDelete">删除</div>
		        <img class='delCartClose' :src="deleteImg"  @click="closeDelCart"></img>
		    </div>
		    <div class='delCartMask'  @touchmove.stop.prevent="noHandle" @click="closeDelCart" v-if='delCartShow'></div>
		
		  <!-- 橘袋命名 -->
		   <div class='newCartBox' v-if='newCartShow' catchtouchmove="noHandle">
		        <div class='newCartBoxName' catchtouchmove="noHandle">服用者姓名</div>
		        <div class='newCartBoxTxt' catchtouchmove="noHandle">你的名字会被印在橘袋上哦～</div>
				
				<div>
					<input type="text" placeholder="请输入姓名…" maxlength='8' @keyup.enter="sureNewCart" @input='inputnewCartName' @blur="blurs" placeholder-class='placeholderclass' class='newCartBoxInput'  :class='inputMark?"redBorder":""' />
				</div>
		        
		        <div class='newcartBtn' @click="sureNewCart">确定</div>
		        <img class='delCartClose' :src="deleteImg" @click="closeNewCart"></img>
		    </div>
		    <div class='delCartMask'  @touchmove.stop.prevent="noHandle" @click="closeNewCart" v-if='newCartShow'></div>
		
		
			<div v-if='toastShow' class='toast'>{{toastMsg}}</div>
		    <div class='creatCartMask' bindtouchstart='touchStart' bindtouchend="touchEnd" @touchmove.stop.prevent="noHandle" @click="cartMaskClose"></div>
		
  </div>
</template>

<script>
import Alert from '@/popup/Alert.vue'
export default {
  name: 'productAddCart',
  components: {
  		Alert
  },
  props: {
    goods: Object,
  },
  data:function () {
    return{
			cartList:[],
			addCartShow:false,
			delCartShow:false,
			delCartname:"我的橘袋",
			delCartid:"0",
			newCartShow:false,
			newCartName:"",
			newCartMark:true,
			inputMark:false,
			newCarRedName:false,
			noCart:false,                //没有橘袋
			deleteImg:require('@/assets/icon-delete.png'),
			addedImg:require('@/assets/added.png'),
			addingImg:require('@/assets/adding.png'),
			AlertShow:false,
			alertMsg:"",
			toastShow:false,
			toastMsg:"加入橘袋",
		}
	},
	created(){
		this.newCarRedName = false
		this.getCartList()
	},
	methods: {
			
		// 获取橘袋列表
		      getCartList: function () {
		        let that = this

				this.axios({
					        method: 'post',
					        url: 'Allcart/getCartList',
					        data: {
					          member_id: this.$store.state.member_id
					        }
					      }).then(res=>{
		          let _cart = res.data.cart_list
		
		          if (_cart.length < 1) {
		                that.cartList= []
		                that.addCartShow=true
		                that.noCart=true
		            return
		          }
		          for (let i = 0, len = _cart.length;i<len;i++){
		            _cart[i].isHave = false
		            _cart[i].goodsNum=0
		            _cart[i].cartName = _cart[i].name
		            if (_cart[i].cartName.length > 7) {
		              _cart[i].cartName = _cart[i].cartName.substring(0,7) + "…"
		            }
		            _cart[i].goodsType = _cart[i].goods_info.length
		            _cart[i].goods_info.forEach((item)=>{
					
		              _cart[i].goodsNum += Number(item.goods_num)
		              if (item.goods_id == that.goods.id){
		                _cart[i].isHave = true
		              }
		            })
		          }

		            that.cartList= _cart
		            that.addCartShow= true
					that.noCart= false
		        })
		      },
		
		
				// 无操作
		      noHandle(){
				  // alert("滑动")
			  },
			  
				// 加入购物车
		      addCartFN(eve){
		        let that = this
		
		
		        let cartItem = eve
		
		        if (cartItem.goods_info.length>7) {
					this.alertMsg = '营养补充须循序渐进，请删减至不超过8种补剂。'
					this.AlertShow  =true
		            return
		        }
				
				this.axios({
			        method: 'post',
			        url: 'Allcart/addCartGoods',
			        data: {
			         cart_id: cartItem.id,
			         goods_id: this.goods.id,
			        }
			      }).then(res=>{
		        
		          if(res.data.code==1){
					  that.getCartList()
					  that.showToast("已加入橘袋")
		              
		          }
		        })
		      },
		    // 移出橘袋前判断橘袋里产品数量
		    cutCartFN(eve){
		      let cartItem = eve
		      if (cartItem.goods_info.length<2){
		          this.delCartname=cartItem.name
		          this.delCartid=cartItem.id
		          this.delCartShow=true
		      }else{
		        this.delCartFN(cartItem.id)
		      }
		    },
		    // 产品移出橘袋
		    delCartFN(cartid){
		      let that = this
			  this.axios({
			      method: 'post',
			      url: 'Allcart/delCartGoods',
			      data: {
			       cart_id: cartid,
			       goods_id: this.goods.id,
			      }
			    }).then(res=>{
		     
		        if (res.data.code == 1) {
		          that.getCartList()
				  that.showToast("已从橘袋移出")
		        }
		      })
		    },
		    // 删除橘袋
		    cartDelete: function () {
		      let cartid = this.delCartid
		      let that = this
		      let _cartList = this.cartList
			  
			  this.axios({
			      method: 'post',
			      url: 'Allcart/delCart',
			      data: {
			       cart_ids: [cartid]
			      }
			    }).then(res=>{
		        _cartList.forEach((item, index, array) => {
		          if (item.id == cartid) {
		            array.splice(index, 1)
		            if(index==0){
						that.newCarRedName = false
		            }
		          }
		        })
		        if (_cartList.length<1){
		            that.noCart = true
		        }
		        
		        that.cartList= _cartList
		        
		        that.setCartNum()
				that.showToast("橘袋删除成功")
		        that.closeDelCart()
		        
		      })
		
		    },
		
		
		    // 关闭删除橘袋
		    closeDelCart(){
				this.delCartShow = false
				this.addCartShow = true
		    },
		    // 关闭
		    closeAddCart:function(){
		      let that = this
			  this.addCartShow = false
		      setTimeout(()=>{
				  this.$parent.addCartShowFN()
		      },500)
		    },
		    // 设置橘袋数
		    setCartNum(){
		     
		    },
		    // 点击新增橘袋
		    newCart(){
		      let that = this
			  this.newCartShow =  true
		    },
		    // 输入橘袋名
		    inputnewCartName(e){
		        this.newCartName = e.target.value
		        this.inputMark = false
		      
		    },
		    // 点击确定创建新自选橘袋
		    sureNewCart(){
		      if (this.newCartName.length<1){
		          this.inputMark=true
		      return
		      }
		
		      if (!this.newCartMark)return
		     
		       this.inputMark = false
		   
		      let that = this
			  this.axios({
			      method: 'post',
			      url: 'Allcart/createCart',
			      data: {
			       member_id: this.$store.state.member_id,
			       goods_id: this.goods.id,
			      }
			    }).then(res=>{
		    
		       
		      
		          that.newCartMark = true
		      
		        if(res.data.code==1){
				  let _msg = that.goods.goods_name +  '已加入新橘袋'
					that.showToast(_msg)
		          that.newCarRedName = true
		 
		          that.changeName(res.data.cart_id)
		          that.setCartNum()
		        }else{
					that.showToast("没有创建新的橘袋")
		         
		        }
		      })
		    },
		    // 修改橘袋名
		    changeName: function (cartid) {
		      let that = this
		      if (this.newCartName=="你"){
		        that.closeNewCart()
		        that.getCartList()
		        return
		      }
			  
			  this.axios({
			      method: 'post',
			      url: 'Allcart/updateFillName',
			      data: {
			       fill_name: this.newCartName,
			       cart_id: cartid
			      }
			    }).then(res=>{
		        if (res.data.code != 1) {
					that.showToast(res.data.msg)
		          
		          return
		        }
		        that.closeNewCart()
		        that.getCartList()
		      })
		    },
		    
		    // 关闭新增橘袋
		    closeNewCart:function(){
		  
		        this.newCartShow=false
		        this.newCartName=""
		        this.addCartShow= true
		   
		    },
		
		    // 点击遮罩
		    cartMaskClose(){
		
		        this.closeAddCart()
		     
		    },
		    // to购物车详情
		    toCartDetail(eve) {
		      console.log(eve)
			 this.$router.push({
			 	name: 'cartDetail',
			 	params: { "cartid":eve}
			 });
		     this.closeAddCart()
		    },
		    // 开始左划
		    touchStart(e) {
		      this.setData({
		        startX: e.changedTouches[0].clientY
		      });
		    },
		    // 左划完成
		    touchEnd(e) {
		      let _cartList = this.data.cartList
		      let endX = e.changedTouches[0].clientY;
		      if (this.data.startX - endX > 60) {
		        this.closeAddCart()
		      }
		    },
		// 关闭alert
		closeAlertShow(){
			this.AlertShow = false
			this.alertMsg = ''
		},
		// 小提示
		showToast(Msg){
			let that = this
			this.toastMsg = Msg
			this.toastShow = true
			setTimeout(()=>{
				that.toastShow = false
				that.toastMsg = ""
			},1500)
		},
	},
}
</script>  

<style>
#productAddCart{
/* 	width: 7.5rem;
	height: 100vh; */
	position: relative;
	z-index: 200;
	background-color: #F4F2F0;
}
.creatcartBox{
  position: fixed;
  width: 7.5rem;
  background:rgba(255,255,255,1);
  box-sizing: border-box;
  height:7.34rem;
  z-index: 191;
  transition: 0.2s all ease-in-out;
  border-bottom:0.01rem solid rgba(0,0,0,0.2) ;
}
.creatcartBoxtop{
  bottom:1.1rem;
}
.creatcartBoxbottom{
  bottom:-7.34rem;
}
.creatcartTitle{
  height:1.03rem;
  position: relative;
  padding: 0 0.4rem;
}
.creatcartName{
  padding-left:0.28rem;
  height:1.02rem;
  line-height:1.02rem;
  font-size:0.32rem;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  color:rgba(20,20,20,1);
  letter-spacing:0.01rem;
  border-bottom: 0.01rem solid rgba(244,242,240,1);
  text-align: left;
}
.creatcartName span{
  color:rgba(194, 94, 77, 1);
  font-weight:bold;
}
.creatcartClose{
  position: absolute;
	right: 0.4rem;
  top:0.1rem;
  width: 0.24rem;
  height: 0.24rem;
  padding: 0.26rem;
  box-sizing: content-box;
  cursor:pointer;
}

.noCartBox{
  width: 7.5rem;
  height:6.3rem;
}
.noCartBoxTitle{
  height:0.69rem;
  font-size:0.48rem;
  font-family:SourceHanSansCN-Medium,SourceHanSansCN;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.72rem;
  text-align: center;
  padding-top: 1.84rem;
  box-sizing: content-box;
}
.noCartBoxBtn{
    position: relative;
    left: 2.25rem;
    top:0.8rem;
    background-color: #C25E4D;
    color: #fff;
    border-radius: 1rem;
    width: 3rem;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.3rem;
    font-weight: 500;
    text-align: center;
    letter-spacing:0.01rem;
    box-shadow: 0rpx 0.16rem 0.25rem -0.05rem rgba(150, 61, 49, 0.4);
	cursor:pointer;
    margin:0 atuo;
  
}


.noCartBoxTxt{
height:0.47rem;
font-size:0.28rem;
font-family:PingFangSC-Light,PingFang SC;
font-weight:300;
color:rgba(80,80,80,1);
line-height:0.44rem;
padding-top: 0.14rem;
text-align: center;
}



.creatcartRowBox{
  width: 7.5rem;
  height:6.3rem;
  overflow-y: auto;
}
.creatcartRowBox::-webkit-scrollbar {display:none}
.creatcartRow{
  padding: 0.19rem 0.4rem 0px 0.68rem;
  height:1.9rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
}

.cartRowcover{
  position: absolute;
  left: 0;
  top:0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.6)
}
.rowcartImg{
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.05rem;
  position: relative;
  overflow: hidden;
}
.rowcartImg img{
  width: 1.4rem;
  height: 1.4rem;
}
.rowcartLab{
  width:0.7rem;
  height:0.38rem;
  line-height: 0.38rem;
  background:#CCB697;
  border-radius:0px 0.05rem 0px 0.05rem;
  position: absolute;
  text-align: center;
  left: 0;
  top:0;
  color:rgba(255,255,255,1);
  font-size:0.2rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
}
.lab0{
  background: #A8B59F;
}
.lab2{
  background: #A3B1BF;
}
.rowcartRight{
  flex: 1;
  height: 1.6rem;
  margin-left: 0.19rem;
  display: flex;
  border-bottom:0.01rem solid rgba(244,242,240,1); 
}
.rowcartTitle{
  height: 1.6rem;
  padding-left:0.05rem; 
  flex: 1;
  box-sizing: border-box;
  text-align: left;

}
.rowcartTitleName{
  height:0.42rem;
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:0.42rem;
  padding-top: 0.26rem;
  box-sizing: content-box;
}
.rowcartTitleName span{
  color:rgba(194, 94, 77, 1);
  margin-left: 0.2rem;
  font-size: 0.24rem;
  position: relative;
  top:-0.015rem;
}
.rowcartTitleTxt{
  height:0.33rem;
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(137,137,137,1);
  padding-top: 0.15rem;
  line-height:0.33rem;
  box-sizing: content-box;
}
.rowcartStaus{
  height: 1.6rem;
  width: 1.14rem;
}
.rowcartStausImg{
  padding: 0.45rem 0.22rem;
  width: 0.7rem;
  height: 0.7rem;
  box-sizing: content-box;
  cursor:pointer;
}

.rowcartStausTxt{
  height:0.33rem;
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(137,137,137,1);
  line-height:0.33rem;
  padding-top:0.56rem;
}

.creatcartBottom{
  position: absolute;
  bottom: 0;
  height: 1.7rem;
  width: 7.5rem;
  background: #fff;
  border-top: 0.01rem solid rgba(244,242,240,1);
}

.creatcartBtn{
    position: absolute;
    bottom:0.6rem;
    right: 0.62rem;
    background-color: #C25E4D;
    color: #fff;
    border-radius: 1rem;
    width: 3rem;
    line-height: 0.88rem;
    font-size: 0.3rem;
    font-weight: 500;
    text-align: center;
    letter-spacing:0.01rem;
    box-shadow: 0rpx 0.16rem 0.25rem -0.05rem rgba(150, 61, 49, 0.4);
	cursor:pointer;
	
}
.creatCartMask{
    width: 7.5rem;
    height:100vh;
    position: fixed;
    bottom:1.1rem;
	left:50%;
	transform: translate(-50%,0); 
    background:rgba(0, 0, 0, 0.6);
    z-index: 190;
}
.delCartMask{
    width: 7.5rem;
    height:100vh;
    position: fixed;
    bottom:1.1rem;
    z-index: 192;
	position: fixed;
	left:50%;
	transform: translate(-50%,0); 
	background:rgba(0, 0, 0, 0.4);
}
.delCartBox{
  width:6.7rem;
  height:4.43rem;
  background:rgba(255,255,255,1);
  border-radius:0.1rem;
  position: fixed;
  z-index: 193;
  top:50%;
  left: 50%;
  transform: translate( -50%, -50%);  
}
.delCartBoxName{
  height:0.69rem;
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium,SourceHanSansCN;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.63rem;
  text-align: center;
  padding-top: 1.2rem;
  box-sizing: content-box;
}
.delCartBoxTxt{
  height:0.47rem;
  font-size:0.28rem;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(80,80,80,1);
  line-height:0.44rem;
  text-align: center;
  padding-top: 0.15rem;
  box-sizing: content-box;
}
.delcartBtn{
    background-color: #C25E4D;
    color: #fff;
    border-radius: 1rem;
    width: 4.15rem;
    line-height: 0.88rem;
    font-size: 0.3rem;
    font-weight: 500;
    text-align: center;
    letter-spacing:0.01rem;
    margin:0.4rem auto 0;
    position: relative;
	cursor:pointer;
}

.delcartBtn::after{
  content:" ";
  width:3.8rem;
  height:0.6rem;
  background:rgba(209,102,89,1);
  border-radius:0.2rem;
  opacity:0.2;
  filter:blur(0.16rem);
  position: absolute;
  top:0.12rem;
  left: 0.19rem;
}
.delCartClose{
  position: absolute;
  right:0.2rem;
  top:0.1rem;
  width: 0.24rem;
  height: 0.24rem;
  padding: 0.26rem;
  box-sizing: content-box;
  cursor:pointer;
}

.newCartBox{
  width:5.8rem;
  height:5.59rem;
  background:rgba(255,255,255,1);
  border-radius:0.1rem;
  position: fixed;
  z-index: 193;
  top:50%;
  left: 50%;
  transform: translate( -50%, -50%);  
}
.newCartBoxName{
  height:0.46rem;
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium,SourceHanSansCN;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.46rem;
  text-align: center;
  padding-top: 0.82rem;
  box-sizing: content-box;
}
.newCartBoxTxt{
  padding-top: 0.47rem;
  height:0.44rem;
  font-size:0.28rem;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(80,80,80,1);
  line-height:0.44rem;
  text-align: center;
  box-sizing: content-box;
}
.newCartBoxInput{
  width:4.38rem;
  height:0.84rem;
  border-radius:0.1rem;
  border:0.02rem solid rgba(216,216,216,1);
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:0.84rem;
  text-align: center;
  margin: 0.21rem auto 0.68rem;
  box-sizing: content-box;
}
.redBorder{
  border:0.02rem solid rgba(209,102,89,1);
}
.placeholderclass{
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(153,153,153,1);
}
.newcartBtn{
  width:2.1rem;
  height:0.88rem;
  background:rgba(194,94,77,1);
  border-radius:0.5rem;
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:0.88rem;
  text-align: center;
  letter-spacing:0.01rem;
  margin:0 auto;
  position: relative;
  cursor:pointer;
}
.newcartBtn::after{
  content:" ";
  width:1.73rem;
  height:1rem;
  background:rgba(209,102,89,1);
  border-radius:0.2rem;
  opacity:0.2;
  filter:blur(0.16rem);
  position: absolute;
  top:0.12rem;
  left: 0.19rem;
}
.toast{
	position: fixed;
	z-index: 999;
	top:50%;
	left: 50%;
	transform: translate( -50%, -50%);
	line-height: 0.4rem;
	opacity: 0.85;
	border-radius: 0.1rem;
	background-color: rgba(85, 85, 85, 1);
	text-align: center;
	padding: 0.04rem 0.2rem;
	color: rgba(255, 255, 255, 1);
	font-size: 0.2rem;
	text-align: left;
	font-family: SourceHanSansSC-regular;
}
</style>